import { ArrowLeft, Trophy01 } from "@untitledui/icons";
import { Button } from "@mfa-aff/ui/components/base/buttons/button";

/** «برگ برنده» tag on the discount-code menu item. */
export const winningBadge = (
    <span className="rounded-full bg-[linear-gradient(135deg,#fde68a,#f59e0b)] px-2 py-0.5 text-[11px] leading-4 font-bold text-[#422006] shadow-xs">
        برگ برنده
    </span>
);

/** The partner's edge with discount codes, at the top of «بازاریابی با کد تخفیف». */
export const WinningCard = () => (
    <section
        aria-labelledby="winning-card"
        className="relative overflow-hidden rounded-2xl bg-[linear-gradient(135deg,#fffbeb_0%,#fef3c7_55%,#fde68a_100%)] p-4 ring-1 ring-[#fcd34d] ring-inset md:p-5 dark:bg-[linear-gradient(135deg,#1c1407_0%,#2a1d06_60%,#3b2a08_100%)] dark:ring-[#a16207]"
    >
        <div className="flex flex-wrap items-start gap-4">
            <span className="flex size-11 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(145deg,#fde68a,#f59e0b)] text-[#422006] shadow-sm" aria-hidden="true">
                <Trophy01 className="size-5" />
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                <h2 id="winning-card" className="text-md font-bold text-[#713f12] dark:text-[#fde68a]">
                    برگ برندهٔ شما در بازاریابی با کد تخفیف
                </h2>
                <p className="text-sm leading-7 text-[#78350f] dark:text-[#fef3c7]">
                    کد تخفیف شما حتی از تخفیف‌هایی که میزبان‌فا به مشتری‌های خودش می‌دهد بیشتر است. شما همکار رسمی میزبان‌فا هستید و با خیال راحت می‌توانید با کد
                    تخفیفتان بفروشید. هر چه به سطح‌های بالاتر بروید، درصد کد تخفیفتان بیشتر می‌شود و شانس فروشتان در هر سطح بالاتر می‌رود.
                </p>
            </div>
            <Button href="/levels" color="secondary" size="sm" iconTrailing={ArrowLeft} className="max-sm:w-full">
                درصد تخفیف در هر سطح
            </Button>
        </div>
    </section>
);
